import Tracking from 'medscape/tracking';
import $  from 'jquery';
import Reflux from 'reflux';
import SlideActionsFactory from './slide-actions-factory';

export default class CarouselTrackingStore extends Reflux.Store
{
    constructor(props)
    {
        super();
        this.props = props;
        this.state = this.getInitialState();
        this.listenables = SlideActionsFactory.get(props["config-id"]);
        this.track();
    }
    getInitialState(){
        return {
            index: ((this.props.settings && this.props.settings.initialSlide) ? this.props.settings.initialSlide : 0)
        };
    }
    afterChange(index){
        this.state.index=index;
        this.track();
    }
    toggleLinks(){
        if($(".links-link.active").length > 0){} else {
            const configId = this.props["config-id"];
            const trackingValue = `carousel-${configId}_links`;
            Tracking.track(trackingValue);
        }
    }
    toggleNotes(){
        if($(".notes-link.active").length > 0){} else {
            const index = this.state.index;
            const configId = this.props["config-id"];
            const slideId = this.props.slides[index].slideId;
            const slideIndex = index<9 ? `s0${index+1}` : `s${index+1}`;
            const trackingValue = `carousel-${configId}-${slideId}_note`;
            Tracking.track(trackingValue);
        }
    }
    track(){
        const index = this.state.index;
        const configId = this.props["config-id"];
        const slideId = this.props.slides[index].slideId;
        const slideIndex = index<9 ? `s0${index+1}` : `s${index+1}`;
        const trackingValue = `carousel-${configId}-${slideId}`;
        if(this.props.settings.slidesToShow === 1){
            Tracking.track(trackingValue);
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/carousel/carousel-tracking-store.js